module.exports = __webpack_public_path__ + "static/sri2012-421a11b6770cde03fb7d1c05603a1057.jpg";